import Header from "./components/header"
import TopText from "./components/toptext"
import BottomText from "./components/bottomtext"
import MemeButton from "./components/memebutton"
import MemeImage from "./components/memeimage"
import TextDisplay from "./components/textdisplay"
import { useState, useEffect } from "react"
import memsData from "./memsData"
import MemeData from "./memsData"


export default function App() {

    const [allMemeImages, setAllMemeImages] = useState([])



    useEffect(() => {
        fetch("https://api.imgflip.com/get_memes")
            .then(res => res.json())
            .then(data => setAllMemeImages(data.data.memes))
    }, [])



    const [meme, setMeme] = useState({
        topText: "",
        bottomText: "",
        randomImage: ""
    })


    function handleChange(event) {
        const { name, type, value, checked } = event.target

        setMeme(prev => {
            return { ...prev, [name]: value }
        })
    }

    function memeClick2() {
        const memesArray = allMemeImages
        const randomNumber = Math.floor(Math.random() * memesArray.length)
        let memeLoc = memesArray[randomNumber].url

        setMeme(prev => ({
            ...prev,
            randomImage: memeLoc
        }))

    }

    function thingClick() {
        thingsArray.push(`Thing${thingsArray.length + 1}`)
        console.log(thingsArray)
    }
    const thingsArray = ["Thing1", "Thing2", "Thing3"]
    const things = thingsArray.map(item => {
        return <p>{item}</p>
    })

    let divStyle = {
        marginTop: "25px"
    }

    return (
        <div className="main-container">
            <Header />
            <div className="app-container">
                <div className="text-container">
                    <TopText handleChange={handleChange} />
                    <BottomText handleChange={handleChange} />
                </div>
                <MemeButton handleClick={memeClick2} />
                <div className="meme-container">
                    {meme.randomImage ? <MemeImage image={meme.randomImage} /> : <div style={divStyle}>Click button above!</div>}
                    <TextDisplay
                        topText={meme.topText}
                        bottomText={meme.bottomText}
                    />
                </div>
            </div>


        </div >
    )
}

